import { useEffect } from 'react';
import useSound from 'use-sound';
import { useSessionStorage } from 'usehooks-ts';
import MessageSound from '@/assets/sounds/ding.mp3?url';
import useNotificationSettings from '@/hooks/settings/use-notification-settings';
import useUserPlatform from '@/hooks/use-user-platform';
import { TRIGGER_SOUND_STORAGE_KEY } from '@/utils/constants';

// NOTE: to have silent sound played immediately after user engagement
export const useUnblockSoundEffect = () => {
  const { isIOS } = useUserPlatform();
  const [playSilentSound] = useSound(MessageSound, { interrupt: true, volume: 0 });
  const { data: notificationSettings } = useNotificationSettings();
  const [triggerSound, setTriggerSound] = useSessionStorage(TRIGGER_SOUND_STORAGE_KEY, false);

  useEffect(() => {
    if (isIOS && !triggerSound && !notificationSettings?.IsNotSound) {
      const play = () => {
        playSilentSound();

        setTriggerSound(true);
        removeEventListener('touchstart', play);
      };
      addEventListener('touchstart', play);
      return () => {
        removeEventListener('touchstart', play);
      };
    }
  }, [isIOS, playSilentSound, notificationSettings, triggerSound]);
};
